import { useState, useEffect } from "react";

const navLinks = [
  { label: "首页", href: "#home" },
  { label: "产品中心", href: "#products" },
  { label: "关于我们", href: "#about" },
  { label: "联系我们", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleAnchor = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMobileOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0A1628]/95 backdrop-blur-md shadow-lg" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-18" style={{ height: "72px" }}>
        {/* Logo */}
        <a href="#home" onClick={(e) => handleAnchor(e, "#home")} className="flex items-center gap-3 cursor-pointer">
          <div className="w-10 h-10 flex items-center justify-center overflow-hidden rounded-md">
            <img
              src="https://static.readdy.ai/image/5f9cc22383cc9e7cc67ed543cf57b925/8fa99cba7f831135614307d2fb67ebf2.jpeg"
              alt="格睿特电子 Logo"
              className="w-10 h-10 object-contain"
            />
          </div>
          <div className="hidden sm:block">
            <p className="text-white font-bold text-base leading-tight tracking-wide">格睿特电子</p>
            <p className="text-[#64B5F6] text-xs leading-tight tracking-widest">GERUITE ELECTRONICS</p>
          </div>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => handleAnchor(e, link.href)}
              className="text-gray-300 hover:text-white text-sm font-medium relative group transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              {link.label}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#0EA5E9] transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>

        {/* CTA Button */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href="#contact"
            onClick={(e) => handleAnchor(e, "#contact")}
            className="px-5 py-2 border border-[#0EA5E9] text-[#0EA5E9] text-sm font-medium rounded-full hover:bg-[#0EA5E9] hover:text-white transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            联系我们
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-8 h-8 flex flex-col items-center justify-center gap-1.5 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <span className={`block w-6 h-0.5 bg-white transition-all duration-300 ${mobileOpen ? "rotate-45 translate-y-2" : ""}`} />
          <span className={`block w-6 h-0.5 bg-white transition-all duration-300 ${mobileOpen ? "opacity-0" : ""}`} />
          <span className={`block w-6 h-0.5 bg-white transition-all duration-300 ${mobileOpen ? "-rotate-45 -translate-y-2" : ""}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden transition-all duration-300 overflow-hidden bg-[#0A1628]/98 backdrop-blur-md ${
          mobileOpen ? "max-h-64 border-t border-white/10" : "max-h-0"
        }`}
      >
        <nav className="flex flex-col px-6 py-4 gap-4">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => handleAnchor(e, link.href)}
              className="text-gray-300 hover:text-white text-sm font-medium py-2 border-b border-white/10 last:border-0 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={(e) => handleAnchor(e, "#contact")}
            className="mt-1 px-5 py-2 bg-[#0EA5E9] text-white text-sm font-medium rounded-full text-center cursor-pointer whitespace-nowrap"
          >
            联系我们
          </a>
        </nav>
      </div>
    </header>
  );
}
